import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { Contribution } from '../models/contribution.model';
import { IContributionApi } from './interfaces/contribution-abstract.api';

@Injectable({
  providedIn: 'root',
})
export class ContributionApi implements IContributionApi {
  constructor(private readonly http: HttpClient) { }

  getContributionSummary(): Observable<Contribution> {
    const url = environment.api.dashboard.myContributionSummary;
    return this.http.get<Contribution>(url);
  }
}
